import { createPortal } from 'react-dom';

import type { FC } from 'react';

import { GlobalPortalProps } from './types';

/** Портал в <div id="node-heap" />. Рендерит `children` или возвращает null. */
export const GlobalPortal: FC<GlobalPortalProps> = ({ children }) => {
	if (!children) return null;

	const heap = document.querySelector('#node-heap');
	if (!heap) {
		console.warn("Element 'node-heap' doesn't exist");
		return null;
	}

	return createPortal(children, heap);
};
